import { render, staticRenderFns } from "./Subtasks.vue?vue&type=template&id=aaf92a24&scoped=true&"
import script from "./Subtasks.vue?vue&type=script&lang=js&"
export * from "./Subtasks.vue?vue&type=script&lang=js&"
import style0 from "./Subtasks.vue?vue&type=style&index=0&id=aaf92a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf92a24",
  null
  
)

export default component.exports